var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62736 0.133789H20.7949C21.0774 0.133789 21.3482 0.24598 21.5479 0.445681C21.7476 0.645382 21.8598 0.916234 21.8598 1.19865V18.2365C21.8598 18.5189 21.7476 18.7898 21.5479 18.9895C21.3482 19.1892 21.0774 19.3014 20.7949 19.3014H1.62736C1.34495 19.3014 1.07409 19.1892 0.874392 18.9895C0.674691 18.7898 0.5625 18.5189 0.5625 18.2365V1.19865C0.5625 0.916234 0.674691 0.645382 0.874392 0.445681C1.07409 0.24598 1.34495 0.133789 1.62736 0.133789ZM11.275 9.38001L4.44713 3.58182L3.06813 5.20468L11.2889 12.1849L19.3616 5.19935L17.9688 3.58821L11.2761 9.38001H11.275Z",
    fill: "#0C75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.eeb7acc9a60de8ac873c0d11d2498b40.svg";
export { ForwardRef as ReactComponent };